import {
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core'
import { getApprovalValues } from 'ducks/selectors'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import { FC } from 'react'
import { useStepperContext } from 'hooks/useStepperContext'
import { STextField, TextFieldLabel } from 'components/UI'
import BooleanCheckbox from 'components/UI/CustomUI/molecules/BooleanCheckbox'

export interface AccessDetailsProps { }

const AccessDetails: FC<AccessDetailsProps> = () => {
  const classes = useStyles()

  const { showWarnings, saveNewValue } = useStepperContext()

  const {
    accessDetails,
    lockboxConsent,
    lockbox,
    isOccupied,
    hasChildrenUnderAge,
    hasPets,
  } = useSelector(getApprovalValues())

  return (
    <>
      <Grid item>
        <Typography className={classes.title}>🔑 access details</Typography>
        <Typography variant="body1" className={classes.latoPrimaryText}>
          Instructions for accessing this property (if any)
        </Typography>
        <STextField
          className={classes.comboUnit}
          value={accessDetails}
          onChange={(event: any) => {
            saveNewValue('accessDetails', event.target.value)
          }}
          placeholder="Gate code is #1234"
        />
        <Grid container style={{ marginTop: 8, marginBottom: 8 }} spacing={2}>
          <Grid item xs={12} md={4} style={{ marginBottom: 8 }}>
            <Typography variant="body1" className={classes.latoPrimaryText}>
              <span style={{ color: showWarnings && isOccupied == null ? 'red' : undefined }}>*</span> Is the property Occupied or Vacant?
            </Typography>
            <FormControl variant="outlined" className={classes.input} fullWidth={false}>
              <Select
                value={
                  isOccupied === true
                    ? 'occupied'
                    : isOccupied === false
                      ? 'vacant'
                      : ''
                }
                onChange={(e) => {
                  const v = e.target.value as string
                  saveNewValue(
                    'isOccupied',
                    v === '' ? null : v === 'occupied'
                  )
                }}
                displayEmpty
                style={{ minHeight: 48, maxWidth: '200px' }}
              >
                <MenuItem value="">
                  <em>Select...</em>
                </MenuItem>
                <MenuItem value="occupied">Occupied</MenuItem>
                <MenuItem value="vacant">Vacant</MenuItem>
              </Select>
            </FormControl>
            {showWarnings && isOccupied == null && (
              <FormHelperText error>Please select whether the property is occupied or vacant.</FormHelperText>
            )}
          </Grid>
          {isOccupied === true && (
            <>
              <Grid item xs={12} md={4} style={{ marginBottom: 8 }}>
                <Typography variant="body1" className={classes.latoPrimaryText}>
                  <span style={{ color: showWarnings && hasChildrenUnderAge == null ? 'red' : undefined }}>*</span> Any children under the age of 18?
                </Typography>
                <BooleanCheckbox
                  onChange={(ev) =>
                    saveNewValue('hasChildrenUnderAge', ev.target.value === 'true')
                  }
                  value={hasChildrenUnderAge}
                  error={showWarnings && hasChildrenUnderAge == null}
                  fullWidth={false}
                />
                {showWarnings && hasChildrenUnderAge == null && (
                  <FormHelperText error>Please select whether the property has children under the age of 18.</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} md={4} style={{ marginBottom: 8 }}>
                <Typography variant="body1" className={classes.latoPrimaryText}>
                  <span style={{ color: showWarnings && hasPets == null ? 'red' : undefined }}>*</span> Any pets?
                </Typography>
                <BooleanCheckbox
                  onChange={(ev) =>
                    saveNewValue('hasPets', ev.target.value === 'true')
                  }
                  value={hasPets}
                  error={showWarnings && hasPets == null}
                  fullWidth={false}
                />
                {showWarnings && hasPets == null && (
                  <FormHelperText error>Please select whether the property has pets.</FormHelperText>
                )}
              </Grid>
            </>
          )}
        </Grid>
        <Typography variant="body1" className={classes.latoPrimaryText}>
          Lockbox code (If applicable)
        </Typography>
        <TextFieldLabel
          label=""
          value={lockbox || ''}
          onChange={(event: any) => {
            saveNewValue('lockbox', event.target.value)
          }}
          placeholder="3466"
          className={classes.input}
        />
      </Grid>

      {!lockbox && (
        <>
          <Grid
            container
            item
            className={classes.consent}
            style={{
              borderColor:
                showWarnings && !lockboxConsent
                  ? 'var(--border-border-error-light)'
                  : '#ACCAFC',
              background: '#FCFCFC',
            }}
          >
            <Checkbox
              checked={lockboxConsent}
              onChange={() => saveNewValue('lockboxConsent', !lockboxConsent)}
              name="lockboxConsent"
              color="primary"
              style={{
                color: showWarnings && !lockboxConsent ? 'red' : 'primary',
                padding: 0,
                height: '24px',
              }}
            />
            <Typography className={classes.consentText}>
              If a lockbox is not provided, an adult 18 or older will meet the Pro
              at the property.
            </Typography>
          </Grid>
          {showWarnings && !lockboxConsent && (
            <FormHelperText error>Please confirm or provide a lockbox code.</FormHelperText>
          )}
        </>
      )}
    </>
  )
}

export default AccessDetails
